export const stripConfig = {
    pk: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
};